module.exports = __webpack_public_path__ + "img/complete.d3240515.svg";